import React, { memo } from 'react'

import {
  Button,
  Icon,
  RotatingSpinner,
  Upload2,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import useThreeDModelUploader from './Hooks/useThreeDModelUploader'

function UploadThreeDModelButton({
  withLabel = false,
  className = undefined,
}) {
  const t = useTranslation()
  const {
    acceptedExtensions,
    inputRef,
    isLoading,
    onFileChange,
    onFileClick,
  } = useThreeDModelUploader()

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={acceptedExtensions.map(ext => `.${ext}`).join(',')}
        onChange={!isLoading ? onFileChange : undefined}
        aria-hidden
        tabIndex={-1}
        disabled={isLoading}
        style={{ display: 'none' }}
      />
      {withLabel ? (
        <Button
          type="secondary"
          variant="with-icon"
          icon={(
            <Icon
              svgComponent={isLoading ? RotatingSpinner : Upload2}
              size="small"
              className="header__button-icon header__button-icon--dark"
            />
          )}
          size="small"
          customClass={classnames("header__button", className)}
          onClick={!isLoading ? onFileClick : undefined}
        >
          {isLoading ? t('shared.uploadModel.uploading') : t('shared.uploadModel.upload')}
        </Button>
      ): (
        <Button
          type="ghost"
          variant="only-icon"
          icon={(
            <Icon
              svgComponent={isLoading ? RotatingSpinner : Upload2}
              size="small"
              notSpaced
              className="header__button-icon header__button-icon--light"
            />
          )}
          size="tiny"
          customClass={classnames("header__button", className)}
          onClick={!isLoading ? onFileClick : undefined}
        />
      )}
    </>
  )
}

UploadThreeDModelButton.propTypes = {
  withLabel: bool,
  className: string,
}

export default memo(UploadThreeDModelButton)
